import { css } from '@emotion/react';
import { ConnectionStatus } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { theme } from '@frontend/theme';

export const getStatusChipStyles = (connectionStatus: ConnectionStatus | undefined) => {
  switch (connectionStatus) {
    case ConnectionStatus.CONNECTION_STATUS_AUTH_FAILED:
    case ConnectionStatus.CONNECTION_STATUS_DISCONNECTED:
      return css({
        backgroundColor: `${theme.colors.critical50}40`, // 40 hexalpha represents 25% opacity
        color: theme.colors.critical70,
      });
    case ConnectionStatus.CONNECTION_STATUS_NOT_CONNECTED:
      return css({
        backgroundColor: theme.colors.warning10,
        color: theme.colors.warning80,
      });
    default:
      return css({
        backgroundColor: theme.colors.critical10,
        color: theme.colors.critical70,
      });
  }
};
